import React from "react";
import { Card, CardBody, Button, Badge } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCart } from "../../../slices/cart/publicOrderingCartSlice";

import { buildOrderPayload } from "../utils/orderPayloadBuilder";
import PublicOrderingServices from "../services/PublicOrderingServices";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import CartItemsList from "./CartItemsList";
import playBeep from "./PlayBeep";

// Desktop Cart Sidebar Component
const DesktopCartSidebar = ({ cart, orgInfo, orgData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orgCode = orgInfo?.orgCode;

  const totalItems = cart.reduce(
    (sum, item) => sum + (item.qty || item.quantity || 0),
    0
  );

  const totalPrice = cart.reduce(
    (sum, item) =>
      sum +
      (item.totalPrice || item.basePrice || item.price || 0) *
        (item.qty || item.quantity || 0),
    0
  );

  const handleOrderNow = async () => {
    const orderPayload = buildOrderPayload(cart);
    const customerInfo = JSON.parse(localStorage.getItem("CustomerInfo"));
    const isLoggedIn = customerInfo?.accessToken;

    if (!isLoggedIn) {
      const pending = { orderPayload, orgData };
      try {
        localStorage.setItem("pendingCheckout", JSON.stringify(pending));
      } catch (e) {
        console.error("Failed to save pending checkout:", e);
      }
      navigate(`/${orgCode}/customer-login`);
      return;
    }

    try {
      console.log("🚀 ~ handleOrderNow ~ orderPayload:", orderPayload)
      const response = await PublicOrderingServices.orderOnline({
        token: customerInfo.accessToken,
        apikey: orgCode,
        orderPayload: orderPayload,
      });
      console.log("🚀 ~ handleOrderNow ~ response:", response);

      console.log("ORDER SUCCESS:", response);
      localStorage.removeItem("publicCartV2");
      dispatch(clearCart());

      navigate(`/${orgCode}/order-summary`, {
        state: {
          orgData,
          orderPost: response,
          orderResponse: response,
        },
      });
    } catch (error) {
      console.error("ORDER FAILED:", error);
      alert(error?.message || "Failed to place order");
    }
  };

  return (
    <Card>
      <CardBody
        style={{
          padding: "0",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 35vh)", 
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px",
            borderBottom: "2px solid #f0f0f0",
            backgroundColor: "#fff",
          }}
        >
          <div className="d-flex align-items-center justify-content-center gap-2">
            {/* Cart Icon */}
            <i
              className="bx bx-cart"
              style={{ fontSize: "24px", color: "#ff7900" }}
            />

            {/* Title */}
            <h5
              className="mb-0 fw-bold"
              style={{ color: "#2c3e50", fontSize: "16px", flex: 1 }}
            >
              Your Order
            </h5>

            {/* Right side actions */}
            <div className="d-flex align-items-center gap-2">
              {/* Trash Button */}
              {cart.length > 0 && (
                <Button
                  color="link"
                  size="sm"
                  // onClick={() => dispatch(clearCart())}
                  onClick={() => {
                    playBeep(), dispatch(clearCart());
                  }}
                  className="text-danger text-decoration-none p-0"
                  style={{
                    fontWeight: "600",
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bx bx-trash" style={{ fontSize: "18px" }} />
                </Button>
              )}

              {/* Badge */}
              {totalItems > 0 && (
                <Badge
                  pill
                  style={{
                    fontSize: "11px",
                    padding: "4px 10px",
                    backgroundColor: "#ff7900",
                    fontWeight: "700",
                  }}
                >
                  {totalItems === 1 ? `${totalItems} item` : `${totalItems} items`}
                </Badge>
              )}
            </div>
          </div>
        </div>

        {/* Cart Items - Scrollable */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "16px",
            backgroundColor: "#f9f9f9",
            maxHeight: "50vh",

            // minHeight: cart.length > 4 ? "80vh" : "auto",
          }}
        >
          <CartItemsList cart={cart} />
        </div>

        {/* Footer - Total & Actions */}
        {cart.length > 0 && (
          <div
            style={{
              padding: "16px",
              backgroundColor: "#fff",
              borderTop: "2px solid #f0f0f0",
            }}
          >
            {/* Total */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 16px",
                backgroundColor: "#fff",
                borderRadius: "10px",
                border: "2px solid #ff7900",
                marginBottom: "12px",
              }}
            >
              <span
                className="fw-bold"
                style={{ fontSize: "14px", color: "#2c3e50" }}
              >
                Total:
              </span>
              <span
                className="fw-bold"
                style={{ fontSize: "16px", color: "#ff7900" }}
              >
                Rs. <NumberWithCommas number={totalPrice} />
              </span>
            </div>

            {/* Order Now Button */}
            <Button
              color="danger"
              block
              className="d-flex align-items-center justify-content-center"
              style={{
                borderRadius: "10px",
                padding: "10px",
                fontWeight: "700",
                fontSize: "15px",
                backgroundColor: "#ff7900",
                border: "none",
                boxShadow: "0 4px 12px rgba(255, 121, 0, 0.3)",
                transition: "all 0.3s ease",
              }}
              // onClick={handleOrderNow}
              onClick={() => {
                playBeep();
                handleOrderNow();
              }}
            >
              <i
                className="bx bx-check-circle me-2"
                style={{ fontSize: "18px" }}
              />
              Order Now
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default DesktopCartSidebar;
